const messages = {
	softwareUpdateSuccess: 'push_notification_has_been_sent',
	softwareUpdateError: 'device_info_messages_error',
};

export default messages;
